import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import ValidationInputsWithRadio from '../../Shared/ValidationInputsWithRadio/ValidationInputsWithRadio';
import {
  suspendOrActivateBusinessAccount,
  GetCustomerDetailsForBusinessContactManager,
  setCustomerNumber,
  setIsShowPopup,
  setIsSimSelected,
  setCustomerSimNumber,
  resetSuspensionReasons,
} from '../PortalsBlock/portalSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import ChangeHetPayPopUp from '../ClientInformationBlock/ChangeHetPayPopUp';
import PopUp from '../../Shared/Popup/PopUp';
import SelectActionPopup from './SelectActionPopup';
import CancellationReasonPopup from './CancellationReasonPopup';
import AlertPopup from './AlertPopup';
import DtonlyPopup from './DtonlyPopup';
import {Col, Row} from 'reactstrap';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import {isMobile} from 'react-device-detect';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import errorIcon from '../PortalsBlock/images/icon-error/icon-120-error.svg';
import likeIcon from '../PortalsBlock/images/icon-like/icon-100-like.svg';
import insightIcon from '../PortalsBlock/images/icon-insight/icon-120-insight.svg';
import dwhSelfCareSuspendActivateAccount from './dwhReports';
import {gtag4} from '../../../utilities/analytics/tracking';

const SuspendAccountMain = (props) => {
  useEffect(() => {
    if (!oldHetPay.id) {
      getOldHetPayName();
    }

    if (isAllowed.isAllowed && isAllowed.description == 'MemberOfDifferentOrg')
      dwhSelfCareSuspendActivateAccount({
        actionType: 'Subscriber Search Page',
        status: 'Ongoing',
        messageText: 'Subscriber associated with another business account',
        ...params,
      });

    gtag4({event: 'SubscriberStatus_PhoneNumPage', action: 'PhoneNumPage'});

    return () => {
      if(props.portalState.suspensionReasons?.length > 0){
        props.resetSuspensionReasons();
      }
    }
  }, []);

  const data = props.iContent;
  const [orgId, setOrgId] = useState('');
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMsg, setAlertMsg] = useState('');
  const [alertIcon, setAlertIcon] = useState('');
  const [showActionPopup, setShowActionPopup] = useState(false);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const [showDtonlyPopup, setShowDtonlyPopup] = useState(false);
  const [showCancellationReasonPopup, setShowCancellationReasonPopup] = useState(false);

  const form = [
    {
      inputName: 'מספר טלפון',
      id: 1,
      formType: 'PHONE',
      pattern: '[0-9]*',
      maxLength: '10',
      regexPattern: '^[0-9]{10}$',
    },
    {
      inputName: 'מספר סים',
      id: 2,
      formType: 'SIM',
      pattern: '[0-9]*',
      maxLength: '18',
      regexPattern: '^[0-9]{18}$',
    },
  ];

  const [typedNumber, setTypedNumber] = useState({
    id: null,
    value: '',
  });

  const [formType, setFormType] = useState({
    id: '',
    formType: '',
  });

  const [isAllowed, setIsAllowed] = useState({
    description: 'initialState',
    isAllowed: false,
  });

  const [oldHetPay, setOldHetPay] = useState({
    id: '',
    name: '',
  });

  const params = {
    param1: props.portalState.selectedHetPay,
    param2: props.portalState.customerSimNumber,
    param10: props.portalState.customerPhoneNumber,
    idNumber: props.authentication.loginData.userDetails.IDNumber,
  };

  const getOldHetPayName = () => {
    props.portalState?.hetPaysNumbers?.map((h) => {
      if (h.id === props.portalState.selectedHetPay)
        setOldHetPay({
          id: h.id,
          name: h.name,
        });
    });
  };

  async function getCustomerNumber(customerNumber, formType) {
    dwhSelfCareSuspendActivateAccount({
      actionType: 'Subscriber Search Page',
      status: 'Ongoing',
      messageText: 'Subscriber Search Page Button Clicked',
      ...params,
    });

    gtag4({event: 'SubscriberStatus_PhoneNumContinueButton', button: 'המשך', action: 'PhoneNumContinueButton'});

    props.showAppLoader();
    let orgId;
    setIsAllowed({description: 'isLoading'});

    props.portalState?.privateCompanyList.map((company) => {
      if (company.idNumber === props.portalState?.selectedHetPay) {
        orgId = company.orgId;
        setOrgId(company.orgId);
      }
    });

    const result = await props.GetCustomerDetailsForBusinessContactManager({
      orgId: orgId,
      customerNumber: customerNumber,
      formType: formType,
    });

    setIsAllowed(result.payload);
    props.setCustomerNumber(result.payload.phoneNumber);

    if (
      result.payload.description === 'MemberOfDifferentOrg' ||
      result.payload.description === 'OrgIdNotFound' ||
      result.payload.isAllowed == true
    ) {
      if (formType == 'SIM') {
        if (customerNumber == props.portalState.customerSimNumber) setShowActionPopup(true);

        props.setCustomerSimNumber(customerNumber);
        props.setIsSimSelected(true);
      } else setShowActionPopup(true);
    }
    props.hideAppLoader();
  }
  const getCustomerValidationErrorDescription = () => {
    let error;
    let dwhMessage = 'Subscriber Not Found';
    let dwhStatus = 'Completed';

    if (isAllowed.description == 'PhoneNumberNotFound') {
      error = `לא נמצא מנוי, אנא נסו שוב`;
    } else if (isAllowed.description == 'AccountNotFound') {
      error = `מנוי זה לא משוייך לאחד מהארגונים שלכם, אנא נסו שוב`;
    } else if (isAllowed.description == 'MemberOfDifferentOrg') {
      error = `מנוי זה משוייך לארגון אחר, אנא נסו שוב`;
    } else if (isAllowed.description == 'ErrorOnValidation' || isAllowed.description == 'Unknown' || isAllowed.error) {
      error = `קרתה תקלה במהלך הזיהוי, אנא נסו שוב`;
      dwhMessage = 'General Error';
      dwhStatus = 'Error';
    }

    dwhSelfCareSuspendActivateAccount({
      actionType: 'Subscriber Search Page',
      status: dwhStatus,
      messageText: dwhMessage,
      ...params,
    });
    gtag4({event: 'SubscriberStatus_PhoneNumErrorMessage', error: dwhMessage, action: 'PhoneNumErrorMessage'});
    return error;
  };

  const getButtonModes = () => {
    if (isAllowed.description === 'initialState') {
      dwhSelfCareSuspendActivateAccount({
        actionType: 'Subscriber Search Page',
        status: 'Ongoing',
        messageText: 'Subscriber Search Page Displayed',
        ...params,
      });
      return (
        <Row className='justify-content-center mt-5'>
          <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!pattern.test(typedNumber.value) && 'disabled-btn'}`}>
            <BtnSubmit isBusiness text={`המשך`} onclick={() => getCustomerNumber(typedNumber.value, formType.formType)} />
          </Col>
        </Row>
      );
    } else if (props.portalState.isSimSelected) {
      dwhSelfCareSuspendActivateAccount({
        actionType: 'Subscriber Search Page',
        status: 'Ongoing',
        messageText: 'Sim search Confirmation phone number',
        ...params,
      });
      return (
        <>
          <Row className='account-denied text-center  mt-4'>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              <p className='font-14 newPurple-text mb-1'>מספר המנוי המשויך לחשבון הוא {props.portalState.customerPhoneNumber}</p>
            </Col>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              <p className='font-14 newPurple-text mb-1'>תרצו להמשיך עם מספר זה?</p>
            </Col>
          </Row>
          <Row className='justify-content-center mt-3'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!pattern.test(typedNumber.value) ? 'disabled-btn' : ''}`}>
              <BtnSubmit isBusiness text={`המשך`} onclick={() => getCustomerNumber(typedNumber.value, formType.formType)} />
            </Col>
          </Row>
          <Row className='justify-content-center mt-2'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
            </Col>
          </Row>
        </>
      );
    } else if ((isAllowed.isAllowed == false || isAllowed.error) && isAllowed.description !== 'MemberOfDifferentOrg') {
      return (
        <>
          <Row className='account-denied text-center  mt-4'>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              <p className='font-14 newPurple-text mb-1'>{getCustomerValidationErrorDescription()}</p>
            </Col>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              {isMobile ? (
                <a href={`tel:${window.Config.businessCallNumber}`} className='font-14 bold asBtn'>
                  אחרת חייגו 234* לשיחה עם צוותון שירות
                </a>
              ) : (
                <p className='font-14 bold mb-0'>חיוג 234* לשיחה עם צוותון שירות</p>
              )}
            </Col>
          </Row>
          <Row className='justify-content-center mt-3'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!pattern.test(typedNumber.value) ? 'disabled-btn' : ''}`}>
              <BtnSubmit isBusiness text={`נסה שוב`} onclick={() => getCustomerNumber(typedNumber.value, formType.formType)} />
            </Col>
          </Row>
          <Row className='justify-content-center mt-2'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
            </Col>
          </Row>
        </>
      );
    }
  };

  let pattern = new RegExp('^.*[a-zA-Z0-9]+.*$');
  const patternTest = () => {
    form.map((f) => {
      if (f.id === typedNumber.id) {
        if (f.regexPattern) {
          pattern = new RegExp(f.regexPattern);
        } else {
          pattern = new RegExp('^.*[a-zA-Z0-9]+.*$');
        }
      }
    });
  };
  patternTest();

  const radioButtonClick = (id, formType) => {
    setFormType({
      id: id,
      formType: formType,
    });
    if (typedNumber.value) {
      setTypedNumber((state) => {
        return {
          id: null,
          value: '',
        };
      });
    }
  };

  const onButtonClick = () => {
    setIsAllowed({
      ...isAllowed,
      isAllowed: true,
    });
  };

  const onPopupClosing = () => {
    setIsAllowed({description: 'initialState'});
    setShowActionPopup(false);
    setShowDtonlyPopup(false);
    setShowAlertPopup(false);
    setShowCancellationReasonPopup(false);
    setOrgId('');
    props.setIsSimSelected(false);
    props.setCustomerNumber(null);
    props.setCustomerSimNumber(null);
    return false;
  };

  const onClickActionButton = async (action,reason) => {
    props.showAppLoader();
    setShowActionPopup(false);
    setShowCancellationReasonPopup(false);


    const msg = showDtonlyPopup == true ? 'DTONLY' : '';
    setShowDtonlyPopup(false);

    let dwhErrorMessage = '';
    let gtag4Message = '';

    /// ----------- DWH ------------- ///
    if (action == 'suspend') {
      dwhSelfCareSuspendActivateAccount({
        actionType: 'Action Selection',
        status: 'Ongoing',
        messageText: 'block account button is clicked',
        ...params,
      });
      gtag4({event: 'SubscriberStatus_BlockAccountButton', button: 'חסימת מנוי', action: 'BlockAccountButton'});
      dwhErrorMessage = 'subscription is already suspended';
      gtag4Message = 'SuspendNumMessage';
    } else {
      dwhSelfCareSuspendActivateAccount({
        actionType: 'Action Selection',
        status: 'Ongoing',
        messageText: 'button to open an account is clicked',
        ...params,
      });
      gtag4({event: 'SubscriberStatus_OpenNewAccountButton', button: 'חסימת מנוי', action: 'OpenNewAccountButton'});
      dwhErrorMessage = 'subscription is already open';
      gtag4Message = 'ActiveNumMessage';
    }

    const req = {
      orgId: orgId,
      selectedNumber: props.portalState.customerPhoneNumber,
      action: action,
      reason: reason,
      canDoAction: false,
      msgCode: '',
      msg: msg,
      formType: formType.formType,
    };
    const result = await props.suspendOrActivateBusinessAccount(req);
    if (result.error || result.payload == null || result.payload?.msg == '-1' || result.payload?.msgCode == '99') {
      setAlertIcon(errorIcon);
      setAlertTitle('הפעולה נכשלה');
      setAlertMsg('חלה שגיאה בעת ביצוע הפעולה, אנא פנו לאחראי שירות');
      setShowAlertPopup(true);
    }

    if (result.payload.msgCode == '00') {
      if (result.payload.msg == 'DTONLY') {
        setAlertIcon(insightIcon);
        setAlertTitle('שימו לב');
        setAlertMsg(
          `מנוי ${props.portalState.customerPhoneNumber} עתיד להפתח מהשהייה ולהתחיל להיות מחוייב מרגע הפתיחה בהתאם לתוכנית החיוב החודשית המותקנת במנוי. האם להמשיך?`
        );
        setShowDtonlyPopup(true);
      } else if (result.payload.canDoAction == true) {
        setAlertIcon(likeIcon);
        setAlertTitle('הפעולה בוצעה בהצלחה');
        setAlertMsg(result.payload.msg);
        setShowAlertPopup(true);
        dwhSelfCareSuspendActivateAccount({
          actionType: action == 'suspend' ? 'Suspend Account' : 'Activate Account',
          status: 'Completed',
          messageText: 'Success',
          ...params,
        });
      } else {
        setAlertIcon(errorIcon);
        setAlertTitle('הפעולה נכשלה');
        setAlertMsg(result.payload.msg);
        setShowAlertPopup(true);
        dwhSelfCareSuspendActivateAccount({
          actionType: 'Action Selection',
          status: 'Error',
          messageText: dwhErrorMessage,
          ...params,
        });
        gtag4({event: 'SubscriberStatus' + gtag4, action: gtag4Message});
      }
    } else {
      setAlertIcon(errorIcon);
      setAlertTitle('הפעולה נכשלה');
      setAlertMsg('לא ניתן לבצע את הפעולה, אנא פנו לאחראי שירות');
      setShowAlertPopup(true);
      dwhSelfCareSuspendActivateAccount({
        actionType: 'Action Selection',
        status: 'Error',
        messageText: 'General Error',
        ...params,
      });
    }
    props.hideAppLoader();
  };

  return (
    <div className='client-information-main suspend-account-main'>
      <ValidationInputsWithRadio
        onButtonClick={getCustomerNumber}
        title={data?.title?.value}
        boldTitle={data?.boldTitle?.value}
        data={isAllowed}
        form={form}
        typedNumber={typedNumber}
        setTypedNumber={setTypedNumber}
        formType={formType}
        setFormType={setFormType}
        getButtonModes={getButtonModes}
        radioButtonClick={radioButtonClick}
      />
      {!isAllowed?.isAllowed ? (
        <PopUp preventWrapperClose={false} showPopUp={showActionPopup} onClose={() => onPopupClosing()}>
          <ChangeHetPayPopUp
            isAllowed={isAllowed}
            setIsAllowed={setIsAllowed}
            oldHetPay={oldHetPay}
            btnText={'המשך בתהליך'}
            onButtonClick={onButtonClick}
            setIsShowPopup={props.setIsShowPopup}
            params={params}
          />
        </PopUp>
      ) : (
        <PopUp preventWrapperClose={false} showPopUp={showActionPopup} onClose={() => onPopupClosing()}>
          <SelectActionPopup
            isAllowed={isAllowed}
            onClickActionButton={onClickActionButton}
            customerPhoneNumber={props.portalState.customerPhoneNumber}
            params={params}
            setShowCancellationReasonPopup={setShowCancellationReasonPopup}
            setShowActionPopup={setShowActionPopup}
          />
        </PopUp>
      )}
      {showDtonlyPopup && (
        <PopUp preventWrapperClose={false} pre showPopUp={showDtonlyPopup} onClose={() => onPopupClosing()}>
          <DtonlyPopup
            content={alertMsg}
            onClickActionButton={onClickActionButton}
            action={'activate'}
            setIsShowDTONLYPopup={showDtonlyPopup}
            params={params}
          />
        </PopUp>
        )}
      {showAlertPopup && (
        <PopUp preventWrapperClose={false} showPopUp={showAlertPopup} onClose={() => onPopupClosing()}>
          <AlertPopup icon={alertIcon} title={alertTitle} content={alertMsg} />
        </PopUp>
      )}
      {showCancellationReasonPopup &&
      <PopUp preventWrapperClose={false} showPopUp={showCancellationReasonPopup} onClose={() => onPopupClosing()}>
        <CancellationReasonPopup
        onClickActionButton={onClickActionButton}
        params={params} />
      </PopUp>
      }
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    portalState: state.portalsBlock,
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  setCustomerNumber,
  setCustomerSimNumber,
  suspendOrActivateBusinessAccount,
  GetCustomerDetailsForBusinessContactManager,
  showAppLoader,
  hideAppLoader,
  setIsShowPopup,
  setIsSimSelected,
  resetSuspensionReasons,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuspendAccountMain);
